import React from 'react'
import { Link } from '@paypalcorp/pp-react'

interface Props {
  className?: string
  href: string
  leftIcon?: React.ReactNode
  children: React.ReactNode
  onClick?: Function
}

const TextLink = ({ className, href, leftIcon, children, onClick }: Props) => {
  const customClassName = className ? ' ' + className : ''
  return (
    <Link
      className={`text-link${customClassName}`}
      href={href}
      leftIcon={leftIcon}
      onClick={onClick}
    >
      <span className="text-link__text">{children}</span>
    </Link>
  )
}

export default TextLink
